import { fetchWithAuth, utilsDatetime } from './utils';

export const fetchDeviceList = async () => {
    const url = new URL(`${process.env.REACT_APP_API_URL}/device/device-list/v2`);

    try {
        const response = await fetchWithAuth(url, {
            method: 'GET',
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.statusText}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Failed to fetch device list:', error);
        throw error;
    }
};


export async function exportDevicesToExcel() {
  try {
    const url = new URL(`${process.env.REACT_APP_API_URL}/device/export`);

    const response = await fetchWithAuth(url, {
      method: 'GET',
    });
    if (response.ok) {
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `Экспорт_устройств_${utilsDatetime()}.xlsx`;

      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } else {
      console.error('Error:', response.statusText);
    }

  } catch (error) {
    console.error('Error fetching logs:', error);
  }
}

export const sendQueueToDevice = async (deveui) => {
  try {
    const url = new URL(`${process.env.REACT_APP_API_URL}/chirpstack/quene`);
    url.searchParams.append('deveui', deveui);

    const response = await fetchWithAuth(url);

    if (!response.ok) {
      throw new Error('Failed to send queue');
    }

    return await response.json();
  } catch (error) {
    console.error('Error sending queue to device:', error);
    throw error;
  }
};

export const sendQueueToDevice2 = async (serialnumber) => {
  try {
    const url = new URL(`${process.env.REACT_APP_API_URL}/device/quene`);
    url.searchParams.append('serialnumber', serialnumber);

    const response = await fetchWithAuth(url);

    if (!response.ok) {
      throw new Error('Failed to send queue');
    }

    return await response.json();
  } catch (error) {
    console.error('Error sending queue to device:', error);
    throw error;
  }
};

export async function fetchDeviceData(deviceId) {

  const url = new URL(`${process.env.REACT_APP_API_URL}/device/detail`);

  url.searchParams.append('_id', deviceId);

  try {
    const response = await fetchWithAuth(url, {
      method: 'GET',
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.statusText}`);
    }

    const data = await response.json();
    return data[0];
  } catch (error) {
    console.error('Failed to fetch device list:', error);
    throw error;
  }

}


export const updateDevice = async (deviceId, values) => {
  try {
    const url = new URL(`${process.env.REACT_APP_API_URL}/device/edit`);
    url.searchParams.append('_id', deviceId);

    const response = await fetchWithAuth(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(values),
    });

    if (!response.ok) {
      throw new Error('Failed to update device');
    }

    return await response.json();
  } catch (error) {
    console.error('Error updating device:', error);
    throw error;
  }
};


export async function createDeviceCs(values) {
    const url = new URL(`${process.env.REACT_APP_API_URL}/device/create-device-cs`);

    const response = await fetchWithAuth(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(values),
    });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText);
    }

    return await response.json();
}


export async function createDevice({ group, address, file }) {
    const formData = new FormData();

    if (file) {
        formData.append('file', file);
    }

    formData.append('application', group);
    formData.append('address', address);

    const url = new URL(`${process.env.REACT_APP_API_URL}/device/create-device`);

    const response = await fetchWithAuth(url, {
        method: 'POST',
        body: formData,
    });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText);
    }

    return await response.json();
}

export async function editDevices(file) {
    const formData = new FormData();

    if (file) {
        formData.append('file', file);
    }

    const url = new URL(`${process.env.REACT_APP_API_URL}/device/edit-devices`);

    const response = await fetchWithAuth(url, {
        method: 'POST',
        body: formData,
    });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText);
    }

    return await response.json();
}

export async function editDevicesNbiot(file) {
    const formData = new FormData();

    if (file) {
        formData.append('file', file);
    }

    const url = new URL(`${process.env.REACT_APP_API_URL}/device/edit-device-nbiot`);

    const response = await fetchWithAuth(url, {
        method: 'POST',
        body: formData,
    });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText);
    }

    return await response.json();
}

export async function createDeviceNbiot({ group, address, file }) {
    const formData = new FormData();

    if (file) {
        formData.append('file', file);
    }

    formData.append('application', group);
    formData.append('address', address);

    const url = new URL(`${process.env.REACT_APP_API_URL}/device/create-device-nbiot`);

    const response = await fetchWithAuth(url, {
        method: 'POST',
        body: formData,
    });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText);
    }

    return await response.json();
}

export async function getFormattedDeviceList() {
    const url = new URL(`${process.env.REACT_APP_API_URL}/device/device-list`);

    url.searchParams.append('limit', 0);
    url.searchParams.append('offset', 0);

    const response = await fetchWithAuth(url);
    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText);
    }

    const data = await response.json();

    return data.map(item => {
        const dev_id = item.id;
        const dev_number = item.device?.dev_number || '';
        const addressData = item.address[0];
        const address = `${addressData.country} ${addressData.region} ${addressData.city} ${addressData.building} ${item.address_number}`;
        return { dev_id, dev_number, address };
    });
}


export async function exportDeviceToExcel({ dataToExport }) {

  const data = dataToExport;
  const url = new URL(`${process.env.REACT_APP_API_URL}/device/exceldevice`);
  try {
    const response = await fetchWithAuth(url, {
      method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      body: JSON.stringify({ data }),
    });

    if (response.ok) {
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `Отчет_потребления_устройства_${utilsDatetime()}.xlsx`;

      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } else {
      console.error('Error:', response.statusText);
    }
  } catch (error) {
    console.error('Error:', error);
  }

}


export async function addDeviceLora(params) {

  const url = new URL(`${process.env.REACT_APP_API_URL}/device/add-device-lora`);

  const response = await fetchWithAuth(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  });
  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(errorText);
  }
  return await response.json();
}


export async function addDeviceNbiot(params) {

  const url = new URL(`${process.env.REACT_APP_API_URL}/device/add-device-nbiot`);

  const response = await fetchWithAuth(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  });
  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(errorText);
  }
  return await response.json();
}

export const fetchRSSI = async (serialnumber) => {
  try {
    const url = new URL(`${process.env.REACT_APP_API_URL}/device/rssi`);
    url.searchParams.append('serialnumber', serialnumber);

    const response = await fetchWithAuth(url, {
      method: 'GET',
    });

    if (!response.ok) {
      if (response.status === 404) {
        return null;
      }
      throw new Error(`Error: ${response.statusText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Failed to fetch RSSI:', error);
    return null;
  }
};


export async function updateAddr(params) {

  const url = new URL(`${process.env.REACT_APP_API_URL}/device/change-address`);

  const response = await fetchWithAuth(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  });
  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(errorText);
  }
  return await response.json();
}